export default __webpack_public_path__ + "static/media/influencia.daa86464.png";